"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ManualRowResize = void 0;
var _manualRowResize = require("./manualRowResize");
exports.PLUGIN_KEY = _manualRowResize.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _manualRowResize.PLUGIN_PRIORITY;
exports.ManualRowResize = _manualRowResize.ManualRowResize;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualRowResize/index.js
// module id = 1475
// module chunks = 0